module.exports = __webpack_public_path__ + "img/bg12.50112f07.jpg";